import { render } from "./PublicationCourses.vue.js?vue&type=template&id=51565df5!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./PublicationCourses.vue?vue&type=template&id=51565df5"
import script from "./PublicationCourses.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./PublicationCourses.vue?vue&type=script&lang=js"
export * from "./PublicationCourses.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./PublicationCourses.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/Web/scripts/pages/publication/PublicationCourses.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "51565df5"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('51565df5', __exports__)) {
    api.reload('51565df5', __exports__)
  }
  
  module.hot.accept("./PublicationCourses.vue.js?vue&type=template&id=51565df5!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./PublicationCourses.vue?vue&type=template&id=51565df5", () => {
    api.rerender('51565df5', render)
  })

}


export default __exports__